const Generic = {
  "menu-click": "menu_click",
  "destination-click": "destination_click",
  "name-pop-up-shown": "name_pop_up_shown",
  "name-submitted": "name_submitted",
  template: "template",
  "widget-groupmember": "widget-groupmember",
  "widget-leaderboard": "widget-leaderboard",
  search: "search",
  "searched-result-clicked": "searched-result-clicked",
  "quick-links-clicked": "quick-links-clicked",
  "home-pressed": "home-pressed",
  "embedded-channel-clicked": "embedded-channel-clicked",
  "dm-clicked": "dm-clicked",
};

const Event = {
  "calendar-clicked": "calendar-clicked",
};
const Notification = {
  "see-notification": "see-notification",
  "notification-clicked": "notification-clicked",
};

const Course = {
  "course-clicked": "course-clicked",
};
const Post = {
  "create-post": "create-post",
  "like-post": "like-post",
  "like-clicked": "like-clicked",
  "share-clicked": "share-clicked",
  "post-clicked": "post-clicked",
  "image-clicked": "image-clicked",
  "post-comment": "post-comment",
  "comment-clicked": "comment-clicked",
  "post-reply": "post-reply",
  "edit-post": "edit-post",
  "delete-post": "delete-post",
  "post-filter": "post-filter",
  "featured-post-clicked": "featured-post-clicked",
};

const Community = {
  "join-community": "join-community",
  "subscribe-community": "subscribe-community",
  "create-community": "create-community",
  "select-community": "select-community",
  "load-community": "load-community",
};

const Profile = {
  "user-profile-clicked": "user-profile-clicked",
  "user-profile-edit": "user-profile-edit",
  "notification-clicked": "notification-clicked",
  "edit-profile": "edit-profile",
};

const Auth = {
  login: "login",
  signup: "signup",
  logout: "logout",
  "profile-details": "profile-details",
  "mobile-register-attempt": "mobile-register-attempt",
  "mobile-register-attempt-redirect-email":
    "mobile-register-attempt-redirect-email",
};

const Group = {
  "create-group": "create-group",
  "join-group": "join-group",
  "create-section": "create-section",
  "join-section": "join-section",
  "group-message": "group-message",
  "explore-group-clicked": "explore-group-clicked",
};

export const AnalyticsEvents = {
  ...Generic,
  ...Event,
  ...Course,
  ...Notification,
  ...Post,
  ...Profile,
  ...Auth,
  ...Group,
  ...Community,
} as const;

export type GEvents = keyof typeof AnalyticsEvents;
